<template>
  <div v-if="hideBtn">
    <img class="imgLink" :src="showAsWIP.img" />
  </div>
  <div v-else @click="doEmit" class="tooltip" @mouseover="onMouseHandler" :class="{ hideBtn: hideBtn }" >
    <span v-if="showAsImg&&showTooltip>''" class="tooltiptext">{{ action }}</span>
    <img  v-else-if="showAsImg" class="imgLink" :src="actionObj.img" :title="actionObj.txt" />
    <div  v-else-if="showSchvaleni" class="showSchvaleni">
        <form @submit.prevent="onSchvaleni">
        <input type="text" name="manualApprovalID" v-model="payload"
               required minlength="3" maxlength="30" size="15" />
        <button class="btn" type="submit">OK</button>
        </form>
    </div>
    <div v-else class="textLink">{{ action }}</div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';

const btnMap = {
   Archivovat:
      { img: require('@/assets/btn-archivovat.png'),
        txt: 'Přesun z hlavního přehledu do archivu zakázek' },
   Archivovano:
      { img: require('@/assets/archived.png'),
        noAction: true,
        txt: 'Zakazka achivovana.' },
   NENAHRANO:
      { img: require('@/assets/btn-zakazka_neulozena.png'),
        noAction: true,
        txt: 'Zakázka nebyla vůbec nahrána do MyWay. Opravte chyby a zakázku pošlete ještě jednou.' },
   DOPLNIT_SCHVALENI:
      { // img: require('@/assets/btn-doplnit_schvaleni.png'),
        showSchvaleni: true,
        hideOnClick: false,
        txt: 'Doplnit schvalovací číslo, které je dle pravidel flotily pro danou zakázku povinné.' },
   SCHVALUJE_SE:
      { img: require('@/assets/btn-cekame_na_schvaleni.png'),
        noAction: true,
        txt: 'Zakázka byla úspěšně uložena a čekáme na schválení. Schválení může trvat i 20 minut.' },
   SKONTROLUJ_ARVAL_SCHVALENI:
      { img: require('@/assets/btn-overit_schvaleni.png'),
        txt: 'Schválení může trvat až 20 minut. Kliknutím ověříte stav schválení.' },
   SCHVALENO:
      { img: require('@/assets/btn-uspesne_schvaleno.png'),
        txt: 'Zakázka byla úspěšně uložena a automaticky schválena v MyWay. Zakázku lze ještě zrušit nebo ji musíte dokončit.' },
   SCHVALENO_S_VYHRADOU:
      { img: require('@/assets/btn-schvaleno_s_vyhradou.png'),
        txt: 'Zakázka byla úspěšně uložena ale řidič musí podepsat ALD formulař !  Zakázku lze ještě zrušit nebo ji musíte dokončit.' },
   DOKONCIT:
      { img: require('@/assets/btn-dokoncit.png'),
        txt: 'Doplnit schvalovací číslo, které je dle pravidel flotily pro danou zakázku povinné.' },
   DOKONCENO:
      { img: require('@/assets/btn-uspesne-dokonceno.png'),
        noAction: true,
        txt: 'Zakázka byla úspěšně uložena, zpracována a zaúčtována v MyWay' },
   MANUALNE_DOKONCENO:
      { img: require('@/assets/btn-manualne-dokonceno.png'),
        noAction: true,
        txt: 'Zakázka byla manualne uložena zpracována a zaúčtována v MyWay' },
   MANUALNE_DOKONCIT:
      { img: require('@/assets/btn-manualne-dokoncit.png'), // zelena fajfka
        txt: 'Zakázku musíte v MyWay nejdříve opravit a pak kliknutim na toto tlacitko ji oznacite jako manualne zpracovanou.' },
   NENI_UZAVRENO:
      { img: require('@/assets/btn-neni-uzavreno.png'), // po kontrole z MW ak to nieje uzavrene
        txt: 'Zakázka neni v MyWay uzavřená. Zakázku musíte v MyWay dokončit nebo smazat.' },
   SMAZAT:
      { img: require('@/assets/btn-smazat_zakazku.png'),
        txt: 'Zakázka byla v MyWay uložena ale obsahuje chyby. Zakázku musíte v MyWay nejdříve smazat.' },
   Smazana:         { noAction: true },
   'Stale aktivni': { noAction: true },
   WIP:
      { img: require('@/assets/wip2.png'), noAction: true, txt: 'Pracujeme na tom ...' },
   NONE:
      { img: require('@/assets/logo.png'), noAction: true, txt: '' },
};
export default {
    props: {
        tooltip:{
            type: String,
            default: null,
            required: false
        },
        id: {
            type: Number,
            default: 0,
            required: true
        },
        action: { 
            type: String,
            default: '',
            required: false,
            method: { type: Function },
        }
    },
    emits: ['action-button-message', 'action-button-mounted'],
setup(props, { emit }) {
        // Reactive data - convert from data() function
        const ctrlKeyStatus = ref(false)
        const payload = ref(null)
        const disabledTS = ref((new Date()).valueOf())
        const hideBtn = ref(false)

        // Computed properties - convert from computed object
        const showAsWIP = computed(() => btnMap['WIP'])
        const showAsImg = computed(() => btnMap[props.action]?.img > '')
        const showSchvaleni = computed(() => btnMap[props.action]?.showSchvaleni === true)
        const actionObj = computed(() => btnMap[props.action])
        const noAction = computed(() => btnMap[props.action]?.noAction === true)
        const showTooltip = computed(() => props.tooltip > '' && ctrlKeyStatus.value)

        // Methods - convert to regular functions
        const doEmit = () => {
            if(showSchvaleni.value) return
            if(noAction.value) return
            const now = (new Date()).valueOf()
            if(disabledTS.value > now) return
            disabledTS.value = now + 1000 * 5
            if(!btnMap[props.action]?.hideOnClick) hideBtn.value = true
            console.log('ActionButton doEmit', props)
            emit('action-button-message',
                {id: props.id, action: props.action, payload: payload.value})
        }

        const onMouseHandler = (event) => {
            ctrlKeyStatus.value = event.ctrlKey
        }

        const onSchvaleni = (event) => {
            console.log('onSchvaleni', payload.value, event)
            event.target.querySelector('button').disabled = true
            event.target.querySelector('input').disabled = true
            setTimeout(function(){
                event.target.querySelector('button').disabled = false
                event.target.querySelector('input').disabled = false
            }, 10 * 1000)
            emit('action-button-message',
                {id: props.id, action: props.action, payload: payload.value})
        }

        // Lifecycle hook - convert mounted() to onMounted()
        onMounted(() => {
            // send info back to parent
            emit('action-button-mounted', {id: props.id, action: props.action})
        })

        return {
            ctrlKeyStatus,
            payload,
            disabledTS,
            hideBtn,
            showAsWIP,
            showAsImg,
            showSchvaleni,
            actionObj,
            noAction,
            showTooltip,
            doEmit,
            onMouseHandler,
            onSchvaleni
        }
    }
}
</script>

<style scoped>
.hideBtn { display: none !important; }

img {  cursor: pointer; height: 35px; }
.leftSpace {  margin-left: 30px; }
.textLink{
    width: 100px;
    height: 25px;
    border-radius: 5px;
    padding: 7px 7px;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
}
.tooltip {
  position: relative;
  display: inline-block;
}
.tooltip .tooltiptext {
  visibility: hidden;
  max-width: 150px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 5px;
  border-radius: 6px;
  line-height: 15px;
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}

.showSchvaleni { display: inline-block; }
.showSchvaleni input { width: 80px; }
.btn {
  border: 0;
  line-height: 1.5;
  padding: 1px 5px 1px 5px;
  font-size: 0.8rem;
  text-align: center;
  color: #fff;
  text-shadow: 1px 1px 1px #000;
  border-radius: 3px;
  background-color: #007bff;
  background-image: linear-gradient(
    to top left,
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0.2) 30%,
    rgba(0, 0, 0, 0)
  );
  box-shadow:
    inset 2px 2px 3px rgba(255, 255, 255, 0.6),
    inset -2px -2px 3px rgba(0, 0, 0, 0.6);
}
.btn:hover { background-color: #55a7ff; }
.btn:active {
  box-shadow:
    inset -2px -2px 3px rgba(255, 255, 255, 0.6),
    inset 2px 2px 3px rgba(0, 0, 0, 0.6);
}

</style>